import {baseNameComparator} from 'common/stringUtils';
import {layoutSelectors} from 'features/layout/redux';
import {State} from 'redux/reducer';
import {createSelector} from 'reselect';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

const getSftpUsers = createSelector(
   layoutSelectors.objectsFromStates,
   (objects: IDiplomatObject[]) =>
      objects
         .filter((o) => o.objectType === DiplomatObjectType.enum.SFTP_USER)
         .sort(baseNameComparator)
);

const getSftpGroups = (state: State) => layoutSelectors.vfsGroupsSelector(state).groups || [];
const getSftpGroupNames = createSelector(getSftpGroups, (groups) => groups.map((g) => g.name));

const sftpUsersCount = createSelector(getSftpUsers, (users) => users.length);

export default {
   getSftpUsers,
   getSftpGroups,
   getSftpGroupNames,
   sftpUsersCount,
};
